import { apiBase, toWsOrigin } from './config';

/** Absolute WebSocket URL for an API path such as `/ws/viewer`. */
export function wsUrl(path: string): string {
  const base = apiBase();
  if (base) return `${toWsOrigin(base)}${path}`;
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${proto}//${window.location.host}${path}`;
}

/** Exponential backoff with jitter: 1s, 2s, 4s ... capped at `max`. */
export function backoffDelay(attempt: number, base = 1000, max = 30_000): number {
  const exp = Math.min(max, base * 2 ** Math.max(0, attempt));
  return Math.round(exp * (0.7 + Math.random() * 0.6));
}

/** Converts whatever the socket handed us into a Uint8Array view. */
export function toUint8(data: ArrayBuffer | Uint8Array): Uint8Array {
  return data instanceof Uint8Array ? data : new Uint8Array(data);
}

let counter = 0;
/** Short unique request id for request/reply correlation. */
export function nextRequestId(): string {
  counter = (counter + 1) % 1_000_000;
  return `r${Date.now().toString(36)}${counter.toString(36)}`;
}
